import styled from 'styled-components'
import { BG_NAME } from 'assets/images'
interface ItemContainerStyledProps {
  color: string
}

const ItemBoxContainer = styled.div`
  margin: 20px 0;
  .row-item {
    display: flex;
    justify-content: space-evenly;
    margin-top: 20px;
  }

  .content {
    text-align: center;
    margin-bottom: 20px;
  }
`

const ListContainer = styled.div`
  margin: 20px;

  .row {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
`

const ItemContainerMain = styled.div`
  position: relative;
  .name-item {
    color: white;
    position: absolute;
    bottom: 0;
    background-image: url(${BG_NAME});
    background-size: cover;
    background-repeat: no-repeat;
    width: 124px;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: -5px;
    height: 32px;
    left: -5px;
    text-align: center;
  }
  .rarity {
    position: absolute;
    width: 20px;
    top: 5%;
    left: 66%;
  }
  .rarity-small {
    position: absolute;
    width: 15px;
    top: 0;
    left: 65%;
  }
  .bg-epic {
    &:before {
      background: linear-gradient(45deg, rgb(18, 18, 19) 0%, rgb(48, 8, 8) 10%, #a4322f94 60%, rgb(18, 18, 18) 100%);
    }
  }
  .bg-rare {
    &:before {
      background: linear-gradient(45deg, rgb(18, 18, 19) 0%, rgb(48, 32, 8) 10%, #795548ad 60%, rgb(18, 18, 18) 100%);
    }
  }
  .bg-legendary {
    &:before {
      background: linear-gradient(45deg, rgb(18, 18, 19) 0%, rgb(8, 48, 11) 10%, #4caf5080 60%, rgb(18, 18, 18) 100%);
    }
  }
  .bg-mythic {
    &:before {
      background: linear-gradient(45deg, rgb(18, 18, 19) 0%, rgb(48, 8, 38) 10%, #b858c88a 60%, rgb(18, 18, 18) 100%);
    }
  }
  .bg-common {
    &:before {
      background: linear-gradient(45deg, rgb(18, 18, 19) 0%, rgb(19, 19, 19) 10%, #a3a3a380 60%, rgb(18, 18, 18) 100%);
    }
  }
`

const ItemContainer = styled.div<ItemContainerStyledProps>`
  cursor: pointer;
  width: 72px;
  height: 72px;
  position: relative;
  background-color: ${({ color }) => color};
  /* &.use-nft{
    .img-box {
      img {
        transform: scaleX(1);
      }
    }
  } */
  &.custom {
    width: 115px;
    height: 115px;

    &:before {
      width: 113px;
      height: 113px;
    }

    &.HEAD {
      img {
      }
    }
  }

  &.active {
    background: #57ed78;

    &:before {
      background: #177254;
    }
  }

  -webkit-clip-path: polygon(
    78% 0%,
    67% 0%,
    33% 0%,
    13% 0%,
    0% 12%,
    0% 27%,
    0% 82%,
    0% 100%,
    40% 100%,
    63% 100%,
    100% 100%,
    100% 75%,
    100% 46%,
    100% 25%
  );
  clip-path: polygon(
    78% 0%,
    67% 0%,
    33% 0%,
    13% 0%,
    0% 12%,
    0% 27%,
    0% 82%,
    0% 100%,
    40% 100%,
    63% 100%,
    100% 100%,
    100% 75%,
    100% 46%,
    100% 25%
  );
  position: relative;

  &:before {
    content: '';
    position: absolute;
    width: 70px;
    height: 70px;
    top: 1px;
    left: 1px;
    background-color: #191d2c;
    display: block;
    -webkit-clip-path: polygon(
      78% 0%,
      67% 0%,
      33% 0%,
      13% 0%,
      0% 12%,
      0% 27%,
      0% 82%,
      0% 100%,
      40% 100%,
      63% 100%,
      100% 100%,
      100% 75%,
      100% 46%,
      100% 25%
    );
    clip-path: polygon(
      78% 0%,
      67% 0%,
      33% 0%,
      13% 0%,
      0% 12%,
      0% 27%,
      0% 82%,
      0% 100%,
      40% 100%,
      63% 100%,
      100% 100%,
      100% 75%,
      100% 46%,
      100% 25%
    );
  }
  .img-box {

    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;

    img {
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
    .img-name {
      padding: 7px;
      margin-bottom: 20px;
    }

    /* .img-default {
      transform: scaleX(-1);
    } */
  }

`

export { ItemBoxContainer, ListContainer, ItemContainer, ItemContainerMain }
